import styled from 'styled-components';

/**
 * Slider label props
 */
export interface SliderLabelProps {
  /** Whether the label represents the currently selected version date */
  selected: boolean;
}

/**
 * A slider label
 */
export const SliderLabel = styled.div<SliderLabelProps>`
  font-family: '${({ theme }) => theme.textStyles.fontFamilyHeader.name}';
  font-weight: ${({ selected }) => (selected ? '600' : '400')};
`;

/**
 * The slider labels wrapper
 */
export const LabelsWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

/**
 * The PolicyVersionSlider wrapper
 */
export const PolicyVersionSliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
